/**
 * file : AllTournament/Index.jsx
 * 설명 : 메인 화면
 */

import btnPrev from "assets/images/btn_prev.png";
import btnNext from "assets/images/btn_next.png";
import vis from "assets/images/vis.jpg";
import bannerImg1 from "assets/images/banner_img1.jpg";
import bannerImg2 from "assets/images/banner_img2.jpg";
import bannerImg3 from "assets/images/banner_img3.jpg";

import Total from "./Total";
import Tab from "./Tap/Index";
import TournamentList from "pages/TournamentRelated/List";
import { Spinner } from "components/Common/Componentization";

import $ from 'jquery';
import { useEffect, useState } from 'react';

export default function Index() {
  
  document.title = 'TMT'
  // 데이터 로딩
  const [dataLoading, setDataLoading] = useState(false);

  useEffect(() => {
    //slick 관련
    $(".visual_slider").slick({
      autoplay:false,
      infinite:true,
      slidesToShow:1,
      dots:false,
      arrows:true,
      speed:800,
      focusOnSelect:false,
      pauseOnHover: false,
      prevArrow:$("#Vis_prev"),
      nextArrow:$("#Vis_next"),
    });
    //slick 관련
    $(".banner_slider").slick({
      autoplay:false,
      infinite:true,
      slidesToShow:3,
      dots:true,
      arrows:true,
      focusOnSelect:true,
      pauseOnHover: false,
          responsive: [
        {
          breakpoint: 668,
          settings: {
            slidesToShow: 1,
            centerMode: true,
                      centerPadding: '120px',
          }
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 1,
            centerMode: true,
                      centerPadding: '50px',
          }
        },
            {
          breakpoint: 376,
          settings: {
            slidesToShow: 1,
            centerMode: true,
                      centerPadding: '30px',
          }
        },
      ]
    });
  }, [])
  
  return (
    <>
      <Spinner show={dataLoading} />
      <div className="visual inner">
        <span className="btn_prev" id="Vis_prev"><img src={btnPrev} alt="btn_prev" /></span>
        <span className="btn_next" id="Vis_next"><img src={btnNext} alt="btn_next" /></span>
        <div className="inner_vis">
          <div className="visual_slider">
            <div className="items">
              <p><img src={vis} alt="visual" /></p>
            </div>
            <div className="items">
              <p><img src={vis} alt="visual" /></p>
            </div>
            <div className="items">
              <p><img src={vis} alt="visual" /></p>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="banner">
          <div className="banner_slider">
            <div className="items">
              <p><img src={bannerImg1} alt="banner" /></p>
            </div>
            <div className="items">
              <p><img src={bannerImg2} alt="banner" /></p>
            </div>
            <div className="items">
              <p><img src={bannerImg3} alt="banner" /></p>
            </div>
            <div className="items">
              <p><img src={bannerImg1} alt="banner" /></p>
            </div>
            <div className="items">
              <p><img src={bannerImg2} alt="banner" /></p>
            </div>
            <div className="items">
              <p><img src={bannerImg3} alt="banner" /></p>
            </div>
          </div>
        </div>
        <TournamentList type="A" setDataLoading={setDataLoading} />
        <Total />
        <Tab />
      </div>
    </>
  )
}